import { POST } from "../config/axios.config";

/**
 * `POST /uploads` takes a multipart body with the field name `files` (up to 10)
 * and answers `{ files: [{ url, key, mimeType, size }] }`.
 *
 * Media fields elsewhere in the API (review photos, wish reference photos)
 * only accept URLs this endpoint issued, so every image must go through here.
 */
export const uploadFiles = async (files) => {
  const list = (Array.isArray(files) ? files : [files]).filter(
    (f) => f instanceof File,
  );
  if (!list.length) return [];

  const formData = new FormData();
  list.forEach((file) => formData.append("files", file));

  const res = await POST("/uploads", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return (res?.data?.files || []).map((file) => file.url).filter(Boolean);
};

export const uploadFile = async (file) => {
  const [url] = await uploadFiles([file]);
  return url || null;
};
